import Cookies from "js-cookie";

const DEFAULT_OPTIONS = {
  expires: 365,
  sameSite: "Lax",
};

export const getCookie = (name) => Cookies.get(name);

export const setCookie = (name, value, options = {}) => {
  Cookies.set(name, value, { ...DEFAULT_OPTIONS, ...options });
};

export const removeCookie = (name) => Cookies.remove(name);
